import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "./Button";

interface Props {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default class RetryButton extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <Button
                type="button"
                onClick={this.props.onClick}
                classes={[
                    "button-retry",
                ]}
            >
                <FontAwesomeLight icon="undo" />Retry
            </Button>
        );
    }
}
